@if (!ticket) {
  <div>Loading</div>
}
@if (ticket) {
  <app-dialog-header
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    [showAuditButton]="allowAudit"
    (auditClicked)="openAudit()"
    [title]="ticket.visit.job.externalJobReference"
    (closeClicked)="onCancelClick()"
    (titleClicked)="copyTitleToClipboard(ticket.visit.job.externalJobReference)"
    [titlePrefixContent]="titlePrefix"
    [additionalContent]="headerActions"
  >
  </app-dialog-header>

  <ng-template #titlePrefix>
    @if (ticket.visit.job.minimumAttendance > 1) {
      <button
        color="warn"
        mat-icon-button
        matTooltip="This job was created with a minimum attendance number of two resources, which usually indicates there are cautions or safety issues."
        aria-label="Warning: Two resources required"
      >
        <mat-icon fontIcon="fa-exclamation-triangle" fontSet="fas"></mat-icon>
      </button>
    }
    @if (ticket.visit.job.externalCaseReference) {
      <span
        class="hazard-case-indicator"
        [matTooltip]="
          'This job is linked to Hazard Case ' +
          ticket.visit.job.externalCaseReference
        "
        aria-label="Warning: Hazard Case job"
      >
        <mat-icon fontIcon="fa-exclamation-triangle" fontSet="fas"></mat-icon>
        Hazard Case
      </span>
    }
  </ng-template>

  <ng-template #headerActions>
    <button
      class="ViewJob"
      [routerLink]="['/jobs/planning', ticket.visit.job.id]"
      color="primary"
      mat-flat-button
    >
      View Job
      <mat-icon
        fontIcon="fa-external-link"
        fontSet="fas"
        style="margin-right: 4px"
      ></mat-icon>
    </button>
    @if (clientConfigService.config.urmServices.enabled) {
      <urm-core-launch-widget
        [externalJobReference]="ticket.visit.job.externalJobReference"
      ></urm-core-launch-widget>
    }
  </ng-template>

  <!--<mat-toolbar [color]="ticket.followOnRequired && !ticket.followOnActioned ? 'warn' : 'accent'" cdkDrag-->
  <!--  cdkDragRootElement=".cdk-overlay-pane" class="fullscreen-toolbar" mat-dialog-title>-->
  <!--  <mat-toolbar-row cdkDragHandle class="compact-toolbar-row move-cursor">-->
  <!--    <div class="toolbar-actions">-->
  <!--      @if (ticket.visit.job.minimumAttendance > 1) {-->
  <!--      <button color="warn" mat-icon-button-->
  <!--        matTooltip="This job was created with a minimum attendance number of two resources, which usually indicates there are cautions or safety issues."-->
  <!--        aria-label="Warning: Two resources required">-->
  <!--        <mat-icon fontIcon="fa-exclamation-triangle" fontSet="fas"></mat-icon>-->
  <!--      </button>-->
  <!--      }-->
  <!--      <span>{{ ticket.visit.job.externalJobReference }}</span>-->
  <!--    </div>-->
  <!--    <span class="flex-spacer"></span>-->
  <!--    <button (click)="onCancelClick()" class="end-button" mat-icon-button matTooltip="Close dialog"-->
  <!--      aria-label="Close dialog">-->
  <!--      <mat-icon>close</mat-icon>-->
  <!--    </button>-->
  <!--  </mat-toolbar-row>-->
  <!--  <mat-toolbar-row class="compact-toolbar-row">-->
  <!--    <div [style.background-color]="ticket.visit.job.priority.backgroundColor"-->
  <!--      [style.color]="ticket.visit.job.priority.foregroundColor" class="priority-badge">-->
  <!--      <span style="font-size: 14px;line-height:14px;">{{ ticket.visit.job.priority.description }}</span>-->
  <!--      <span style="font-size: 12px;line-height:12px;">Due {{ ticket.visit.job.planningWindowEnd | amDateFormat:-->
  <!--        'DD/MM/YYYY HH:mm' }}</span>-->
  <!--    </div>-->
  <!--    <span class="flex-spacer"></span>-->
  <!--    <div class="toolbar-actions">-->
  <!--      @if (allowAudit) {-->
  <!--      <button (click)="openAudit()" [disabled]="loading" color="primary" mat-icon-button matTooltip="View Audit History"-->
  <!--        aria-label="View Audit History">-->
  <!--        <mat-icon fontIcon="fa-history" fontSet="fas" style="font-size:22px;"></mat-icon>-->
  <!--      </button>-->
  <!--      }-->
  <!--      <button [routerLink]="['jobs/planning', ticket.visit.job.id]" color="primary" mat-flat-button>-->
  <!--        View Job-->
  <!--      </button>-->
  <!--      @if (clientConfigService.config.urmServices.enabled) {-->
  <!--      <urm-core-launch-widget [externalJobReference]="ticket.visit.job.externalJobReference"></urm-core-launch-widget>-->
  <!--      }-->
  <!--    </div>-->
  <!--  </mat-toolbar-row>-->
  <!--</mat-toolbar>-->
  <mat-dialog-content class="fullscreen-dialog">
    <mat-tab-group [backgroundColor]="'primary'">
      <mat-tab label="Planning">
        <div class="row space-around align-start ticket-details">
          <div>
            <mat-list>
              <h3 mat-subheader>Priority</h3>
              <mat-list-item>
                <div
                  [style.background-color]="
                    ticket.visit.job.priority.backgroundColor
                  "
                  [style.color]="ticket.visit.job.priority.foregroundColor"
                  class="priority-badge-inline"
                >
                  <span
                    style="
                      font-size: 14px;
                      line-height: 14px;
                      padding-bottom: 3px;
                    "
                    >{{ ticket.visit.job.priority.description }}</span
                  >
                  <span style="font-size: 12px; line-height: 12px"
                    >Due
                    {{
                      ticket.visit.job.planningWindowEnd
                        | amDateFormat: "DD/MM/YYYY HH:mm"
                    }}</span
                  >
                </div>
              </mat-list-item>
            </mat-list>

            <div class="section-container">
              <h3 mat-subheader>
                {{ isCompleted ? "Booking History" : "Appointment" }}
              </h3>
              <app-visit-booking-button
                class="appointment-button"
                [visitId]="ticket.visit.id"
                [visitStatus]="ticket.visit.visitStatus"
                [appointmentStart]="ticket.visit.appointmentStart"
                [appointmentEnd]="ticket.visit.appointmentEnd"
                [orchestrated]="isProject"
                (actionCompleted)="reload()"
              ></app-visit-booking-button>
            </div>
            <div class="section-container">
              <h3 mat-subheader>Restrictions</h3>
              <div class="restrictions-chips">
                <mat-chip-set class="restrictions-chip-grid">
                  <!-- Resource Restriction Chip -->
                  @if (ticket.lockToResource) {
                    <mat-chip
                      class="restriction-chip resource-chip"
                      (click)="
                        allowForceBooking &&
                          !isProject &&
                          openManualPlanningDialog()
                      "
                      [disabled]="!allowForceBooking || isProject"
                    >
                      @if (ticket.lockToResource.imageUrl) {
                        <img
                          [src]="ticket.lockToResource.imageUrl"
                          alt="{{ ticket.lockToResource.name }}"
                          class="avatar-image"
                        />
                      }
                      <div class="chip-content">
                        <span class="resource-name">{{
                          ticket.lockToResource.name
                        }}</span>
                      </div>
                    </mat-chip>
                  } @else {
                    <mat-chip
                      class="restriction-chip default-chip"
                      (click)="
                        allowForceBooking &&
                          !isProject &&
                          openManualPlanningDialog()
                      "
                      [disabled]="!allowForceBooking || isProject"
                    >
                      <mat-icon>person</mat-icon>
                      <div class="chip-content">
                        <span class="resource-name">Any Resource</span>
                      </div>
                    </mat-chip>
                  }

                  <!-- Start Time Restriction Chip -->
                  @if (ticket.forceStartTime) {
                    <mat-chip
                      class="restriction-chip time-chip"
                      (click)="
                        allowForceBooking &&
                          !isProject &&
                          openManualPlanningDialog()
                      "
                      [disabled]="!allowForceBooking || isProject"
                    >
                      <mat-icon>schedule</mat-icon>
                      <div class="chip-content">
                        <span class="resource-name"
                          >Start at
                          {{
                            ticket.forceStartTime | amDateFormat: "HH:mm"
                          }}</span
                        >
                      </div>
                    </mat-chip>
                  } @else {
                    <mat-chip
                      class="restriction-chip default-chip"
                      (click)="
                        allowForceBooking &&
                          !isProject &&
                          openManualPlanningDialog()
                      "
                      [disabled]="!allowForceBooking || isProject"
                    >
                      <mat-icon>schedule</mat-icon>
                      <div class="chip-content">
                        <span class="resource-name">Any Start Time</span>
                      </div>
                    </mat-chip>
                  }
                </mat-chip-set>
              </div>
            </div>
            <mat-list>
              <div style="display: flex; align-items: center">
                <h3 mat-subheader>Planner Note</h3>
                <div style="display: flex; align-items: center; gap: 12px">
                  @if (!loadingComment) {
                    <i
                      class="fa-solid fa-pencil"
                      (click)="openPlannerNoteDialog()"
                      [matTooltip]="
                        currentComment
                          ? 'Edit planner note'
                          : 'Add planner note'
                      "
                      [attr.aria-label]="
                        currentComment
                          ? 'Edit planner note'
                          : 'Add planner note'
                      "
                      style="cursor: pointer; color: #203864; font-size: medium"
                    ></i>
                    <!--                    <button mat-flat-button (click)="openPlannerNoteDialog()" color="primary"-->
                    <!--                            [matTooltip]="currentComment ? 'Edit planner note' : 'Add planner note'"-->
                    <!--                            [attr.aria-label]="currentComment ? 'Edit planner note' : 'Add planner note'">-->
                    <!--                      {{ currentComment ? 'Edit Note' : 'Add Note' }}-->
                    <!--                    </button>-->
                  }
                  @if (saving) {
                    <span>Saving...</span>
                  }
                </div>
              </div>
              @if (!loadingComment && !currentComment) {
                <mat-list-item></mat-list-item>
              }
              @if (!loadingComment && currentComment) {
                <mat-list-item>
                  <div class="wrapped-text">
                    {{ currentComment.content?.trim() }}
                  </div>
                </mat-list-item>
              }
              @if (loadingComment) {
                <mat-list-item>Checking for comments</mat-list-item>
              }
            </mat-list>
          </div>
          <div>
            <mat-vertical-stepper
              #timeStepper
              [linear]="false"
              selectedIndex="5"
            >
              <mat-step
                [completed]="isDespatched"
                editable="true"
                label="Despatched"
                state="number"
              >
                <ng-template matStepLabel>
                  @if (isDespatched) {
                    <span
                      >Despatched at
                      {{ ticket.despatchedTime | amDateFormat: "HH:mm" }}</span
                    >
                  }
                  @if (!isDespatched) {
                    <span>Not Despatched</span>
                  }
                </ng-template>
              </mat-step>
              <mat-step
                [completed]="isEnRoute"
                editable="true"
                label="En route"
                state="number"
              >
                <ng-template matStepLabel>
                  <!--                <span *ngIf="isEnRoute">En Route at {{ ticket.enrouteTime | amDateFormat: 'HH:mm' }}</span>-->
                  <span
                    >En Route at {{ ticket.enrouteTime | amDateFormat: "HH:mm"
                    }}<br />
                    <i
                      >{{ formatSeconds(ticket.distanceFromPrevious) }} expected
                      travel&nbsp;</i
                    ></span
                  >
                </ng-template>
              </mat-step>
              <mat-step
                [completed]="isArrived"
                editable="true"
                label="Arrived"
                state="number"
              >
                <ng-template matStepLabel>
                  @if (isArrived) {
                    <span
                      >Arrived at
                      {{ ticket.arrivedTime | amDateFormat: "HH:mm" }}</span
                    >
                  }
                  @if (!isArrived) {
                    <span
                      >Arrival at {{ ticket.arrivedTime | amDateFormat: "HH:mm"
                      }}<br />
                      <i>{{ formatSeconds(ticket.waitingTime) }} wait/prep</i>
                    </span>
                  }
                </ng-template>
              </mat-step>
              <mat-step
                [completed]="isStarted"
                editable="true"
                label="Started"
                state="number"
              >
                <ng-template matStepLabel>
                  <span
                    >Started at {{ ticket.startedTime | amDateFormat: "HH:mm"
                    }}<br />
                    <i>{{ ticket.duration }} minutes work</i>
                  </span>
                </ng-template>
              </mat-step>
              <mat-step
                [completed]="isCompleted"
                editable="true"
                label="Completed"
                state="number"
              >
                <ng-template matStepLabel>
                  <span
                    >Completed at
                    {{ ticket.completedTime | amDateFormat: "HH:mm" }}</span
                  >
                </ng-template>
              </mat-step>
              <ng-template matStepperIcon="edit">
                <mat-icon>check</mat-icon>
              </ng-template>
              <ng-template matStepperIcon="done"></ng-template>
            </mat-vertical-stepper>
            @if (
              (ticket.ticketStatus === "DESPATCHED" ||
                ticket.ticketStatus === "ENROUTE") &&
              isRecallAllowed
            ) {
              <div class="timeline-recall-action">
                <button
                  (click)="recallTicket()"
                  [disabled]="loading || ticket.recallPending"
                  color="warn"
                  mat-flat-button
                >
                  <mat-icon>rotate_left</mat-icon>
                  @if (ticket.recallPending) {
                    <span>Recall In Progress</span>
                  } @else {
                    <span>Recall Ticket</span>
                  }
                </button>
              </div>
            }
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Details">
        <div class="ticket-details">
          <div class="row space-between align-start">
            <h3 mat-subheader>Job Description</h3>
          </div>
          <div class="row space-between align-start">
            <urm-job-description-widget
              [compact]="true"
              [externalJobReference]="ticket.visit.job.externalJobReference"
            ></urm-job-description-widget>
          </div>

          @if (
            ticket.visit.visitScheduleList &&
            ticket.visit.visitScheduleList.length > 0
          ) {
            <mat-list>
              <div
                class="schedules-header"
                (click)="schedulesExpanded = !schedulesExpanded"
                style="
                  cursor: pointer;
                  display: inline-flex;
                  align-items: center;
                  margin: 5px;
                "
              >
                <h3 mat-subheader style="flex: 1; margin: 0">Schedules</h3>
                <mat-icon>{{
                  schedulesExpanded ? "expand_less" : "expand_more"
                }}</mat-icon>
              </div>
              @if (schedulesExpanded) {
                @for (
                  schedule of ticket.visit.visitScheduleList;
                  track schedule
                ) {
                  <mat-list-item>
                    <mat-icon
                      fontIcon="fa-wrench"
                      fontSet="far"
                      style="align-content: end"
                      matListItemAvatar
                    ></mat-icon>
                    <span mat-line
                      >{{ schedule.sorCode }} x{{ schedule.quantity }} -
                      {{ schedule.smv }} minutes</span
                    ><br />
                    <span mat-line> {{ schedule.sorDescription }}</span>
                    <!--                    <span mat-line>{{ schedule.quantity }}x {{ schedule.sorDescription }}</span><br>-->
                    <!--                    <span mat-line>SMV: {{ schedule.smv }} minutes, Code: {{ schedule.sorCode }}</span>-->
                  </mat-list-item>
                }
              }
            </mat-list>
          }

          <div class="row space-between align-start">
            @if (canAmend()) {
              <button
                style="padding-top: 5px"
                mat-flat-button
                (click)="amendRequirements()"
                color="primary"
              >
                Amend Requirements
              </button>
            }
            @if (!canAmend()) {
              <div class="column">
                <button
                  style="margin-left: 20px"
                  mat-flat-button
                  disabled
                  color="default"
                >
                  Amend Requirements
                  <span> ({{ getAmendRestrictionReason() }})</span>
                </button>
                <br />
                @if (canAmendDuration()) {
                  <button
                    style="margin-left: 20px"
                    mat-flat-button
                    color="primary"
                    (click)="alterDuration()"
                  >
                    Amend duration
                  </button>
                } @else {
                  <button
                    style="margin-left: 20px"
                    mat-flat-button
                    disabled
                    color="default"
                  >
                    Amend duration
                    <span> ({{ getAmendRestrictionReason() }})</span>
                  </button>
                }
              </div>
            }
          </div>

          <div class="row space-between align-start">
            <div class="flex-1">
              <mat-list>
                <h3 mat-subheader>Skills</h3>
                <mat-list-item>
                  <mat-icon
                    fontIcon="fa-wrench"
                    fontSet="far"
                    style="align-content: end"
                  ></mat-icon>
                  <span mat-line style="vertical-align: text-bottom">{{
                    ticket.skillProfile?.description ?? "Not specified"
                  }}</span>
                  <!--                  <span mat-line>Skill Profile</span>-->
                </mat-list-item>
              </mat-list>
              <mat-list>
                <h3 mat-subheader>Duration</h3>
                <mat-list-item>
                  <mat-icon
                    fontIcon="fa-clock"
                    fontSet="far"
                    style="align-content: end"
                  ></mat-icon>
                  <span mat-line style="vertical-align: text-bottom"
                    >{{ ticket.duration }} minutes</span
                  >
                </mat-list-item>
                @if (
                  ticket.resourceAvailability?.resource?.efficiencyPercentage &&
                  ticket.resourceAvailability.resource.efficiencyPercentage !==
                    100
                ) {
                  <mat-list-item>
                    <mat-icon
                      fontIcon="fa-gauge"
                      fontSet="fas"
                      style="align-content: end; color: #666"
                    ></mat-icon>
                    <span
                      mat-line
                      style="
                        vertical-align: text-bottom;
                        font-style: italic;
                        color: #666;
                      "
                    >
                      Adjusted from
                      {{ ticket.baseDuration ?? ticket.duration }} mins ({{
                        ticket.resourceAvailability.resource
                          .efficiencyPercentage
                      }}% efficiency)
                    </span>
                  </mat-list-item>
                }
              </mat-list>

              <mat-list>
                <h3 mat-subheader>Cautions</h3>
                <mat-list-item style="padding-right: 0">
                  <urm-caution-widget
                    [externalPropertyReference]="
                      ticket.visit.job.externalPropertyReference
                    "
                    mode="verbose"
                  ></urm-caution-widget>
                </mat-list-item>
              </mat-list>
            </div>
            <div style="flex: 1">
              <mat-list>
                <h3 mat-subheader>Address</h3>
                <mat-list-item>
                  <urm-property-info
                    [externalPropertyReference]="
                      ticket.visit.job.externalPropertyReference
                    "
                    [listView]="true"
                  ></urm-property-info>
                </mat-list-item>
              </mat-list>

              <mat-list>
                <h3 mat-subheader>Contact Information</h3>
                <mat-list-item>
                  <urm-job-contact-widget
                    [externalJobReference]="
                      ticket.visit.job.externalJobReference
                    "
                  ></urm-job-contact-widget>
                </mat-list-item>
              </mat-list>
            </div>
          </div>

          @if (forbiddenList.length > 0) {
            <mat-list>
              <h3 mat-subheader>Excluded Resources</h3>
              @for (item of forbiddenList; track item) {
                <mat-list-item>
                  <span mat-line>{{ item }}</span>
                </mat-list-item>
              }
            </mat-list>
          }
        </div>
      </mat-tab>

      <mat-tab [label]="isCompleted ? 'Booking History' : 'Follow On'">
        <div class="ticket-details follow-on-content">
          @if (ticket.ticketCompletionCode) {
            <div class="follow-on-section">
              <h3 mat-subheader>Completion Code</h3>
              <div class="follow-on-item">
                <h4>
                  {{ ticket.ticketCompletionCode.description }} ({{
                    ticket.ticketCompletionCode.code
                  }})
                </h4>
              </div>
            </div>
          }
          @if (operativeNote) {
            <div class="follow-on-section">
              <h3 mat-subheader>Operative Note</h3>
              <div class="follow-on-item">
                <h4>{{ operativeNote }}</h4>
                <p class="follow-on-meta">
                  <i>{{ operativeNoteResource }}</i>
                </p>
              </div>
            </div>
          }
          @if (followOnComment) {
            <div class="follow-on-section">
              <h3 mat-subheader>Follow On Note</h3>
              <div class="follow-on-item">
                <h4>{{ followOnComment }}</h4>
                <p class="follow-on-meta">
                  <i>{{ followOnResource }}</i>
                </p>
              </div>
            </div>
          }
          <div class="follow-on-section">
            <h3 mat-subheader>Actions</h3>
            @if (ticket.visit.job.status !== JobStatus.CLOSED) {
              <div class="follow-on-action">
                <button
                  (click)="createFollowOn()"
                  [disabled]="loading || isProject"
                  color="primary"
                  mat-flat-button
                >
                  Create Follow On
                  @if (ticket.followOnRequired && ticket.followOnActioned) {
                    <span>(Already Actioned)</span>
                  }
                  @if (!ticket.followOnRequired) {
                    <span>(Not Required)</span>
                  }
                  @if (isProject) {
                    <span> (Project Jobs Restricted)</span>
                  }
                </button>
              </div>
              @if (ticket.followOnRequired && !ticket.followOnActioned) {
                <div class="follow-on-action">
                  <button
                    (click)="clearFollowOn()"
                    [disabled]="loading"
                    color="primary"
                    mat-flat-button
                    aria-label="Mark follow-on as not required"
                  >
                    Mark as Not Required
                  </button>
                </div>
              }
            }
            @if (ticket.visit.job.status === JobStatus.CLOSED) {
              <div class="follow-on-item">
                <p>Job Closed - Unable to create Follow On</p>
              </div>
            }
            @if (
              ticket.ticketStatus !== "COMPLETE" &&
              ticket.ticketStatus !== "PLANNING"
            ) {
              <div class="follow-on-action">
                <button
                  (click)="forceCompletion()"
                  [disabled]="loading"
                  color="primary"
                  mat-flat-button
                >
                  Force Completion
                </button>
              </div>
            }
            @if (
              (ticket.ticketStatus === "DESPATCHED" ||
                ticket.ticketStatus === "ENROUTE") &&
              isRecallAllowed
            ) {
              <div class="follow-on-action">
                <button
                  (click)="recallTicket()"
                  [disabled]="loading || ticket.recallPending"
                  color="warn"
                  mat-flat-button
                >
                  @if (ticket.recallPending) {
                    <span>Recall In Progress</span>
                  } @else {
                    <span>Recall Ticket</span>
                  }
                </button>
              </div>
            }
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-dialog-content>
}
